import { FC } from 'react'
import { AccountLayout } from '../components/layout/AccountLayout'
import { MyLeasesContent } from '../components/management/leases/MyLeasesContent'

export const MyLeasesPage: FC = () => (
  <AccountLayout>
    <MyLeasesContent />
  </AccountLayout>
)

export default MyLeasesPage
